/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import JsBarcode from 'jsbarcode';
import type { TDocumentDefinitions, Content, Margins } from 'pdfmake/interfaces';

interface Iitens {
  qtds: number;
  un: string;
  preco: number;
  total: number;
  subtotal: number;
  localizado?: string;
  referencia?: string;
  filtro: string;
  descricao: string;
}

interface IEmpresa {
  nome: string;
  fantasia?: string;
  cnpj?: string;
  ie?: string;
  endereco?: string;
  numero?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  cep?: string;
  telefone?: string;
  logo?: string;
}

interface IgetImpressao {
  idmov: string;
  dataoperacao: string;
  numero: string;
  total: number;
  vprod: number;
  desconto: number;
  acrescimo: number;
  cidade?: string;
  uf?: string;
  vendedor?: string;
  celular?: string;
  cep?: string;
  nome?: string;
  endereco?: string;
  obs?: string;
  itens: Iitens[];
  empresa: IEmpresa[];
}

const getBase64FromUrl = async (url: string): Promise<string | null> => {
  try {
    if (!url || url === '') {
      return null;
    }

    const response = await fetch(url, {
      mode: 'cors',
      cache: 'no-cache'
    });

    if (!response.ok) {
      console.error('Erro ao carregar imagem:', response.status, response.statusText);
      return null;
    }

    const blob = await response.blob();

    if (!blob.type.startsWith('image/')) {
      console.error('O arquivo não é uma imagem válida:', blob.type);
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const result = reader.result as string;
        if (result && result.startsWith('data:image')) {
          resolve(result);
        } else {
          reject(new Error('Formato de imagem inválido'));
        }
      };

      reader.onerror = () => {
        reject(new Error('Erro ao ler o arquivo'));
      };

      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Erro ao carregar logo:', error);
    return null;
  }
};

const ajustarDimensoesLogo = async (logoBase64: string, maxWidth: number, maxHeight: number): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const proporcao = img.width / img.height;
      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        width = maxWidth;
        height = width / proporcao;
      }

      if (height > maxHeight) {
        height = maxHeight;
        width = height * proporcao;
      }

      resolve({ width, height });
    };
    img.onerror = () => {
      resolve({ width: 60, height: 40 });
    };
    img.src = logoBase64;
  });
};

async function PDFVendaTermica(dados: IgetImpressao, isOrcamento: boolean = false): Promise<Blob> {
  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf',
    },
  };

  pdfMake.vfs = (pdfFonts as any)?.pdfMake?.vfs || pdfFonts;

  const empresa = dados.empresa?.[0];

  let logoBase64: string | null = null;
  let logoDimensoes = { width: 60, height: 40 };

  if (empresa?.logo) {
    try {
      const baseUrl = window.env?.REACT_APP_URL_IMGLOG || '';
      const url = `${baseUrl}${empresa.logo}`;

      logoBase64 = await getBase64FromUrl(url);

      if (logoBase64) {
        logoDimensoes = await ajustarDimensoesLogo(logoBase64, 80, 60);
      }
    } catch (error) {
      console.error('Erro ao carregar logo:', error);
      logoBase64 = null;
    }
  }

  const gerarCodigoBarras = (texto: string) => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 250;
      canvas.height = 50;

      JsBarcode(canvas, texto, {
        format: 'CODE128',
        height: 35,
        width: 1.5,
        displayValue: true,
        fontSize: 14,
        font: 'monospace',
        textAlign: 'center',
        textPosition: 'bottom',
        textMargin: 3,
        background: '#ffffff',
        lineColor: '#000000',
      });

      return canvas.toDataURL('image/png');
    } catch (error) {
      console.error('Erro ao gerar código de barras:', error);
      const canvas = document.createElement('canvas');
      canvas.width = 250;
      canvas.height = 50;
      return canvas.toDataURL('image/png');
    }
  };

  const codigoBarras = gerarCodigoBarras(dados.idmov);

  const LIMITE_ITENS = 20;
  const paginas: Iitens[][] = [];

  for (let i = 0; i < dados.itens.length; i += LIMITE_ITENS) {
    paginas.push(dados.itens.slice(i, i + LIMITE_ITENS));
  }

  const content: Content[] = [];

  paginas.forEach((itensPagina, index) => {
    // ===== CABEÇALHO =====
    
    // LOGO
    if (logoBase64 && logoBase64.startsWith('data:image')) {
      content.push({
        image: logoBase64,
        width: logoDimensoes.width,
        height: logoDimensoes.height,
        alignment: 'center' as const,
        margin: [0, 0, 0, 2] as Margins,
      });
    }

    // NOME DA EMPRESA
    content.push({
      text: (empresa?.fantasia || empresa?.nome || '').toUpperCase(),
      bold: true,
      fontSize: 16,
      alignment: 'center' as const,
      margin: [0, 0, 0, 2] as Margins,
    });

    // ENDEREÇO E TELEFONE
    const enderecoCompleto = [
      empresa?.endereco,
      empresa?.numero,
      empresa?.bairro,
      empresa?.cidade,
      empresa?.uf,
      empresa?.cep
    ].filter(Boolean).join(', ');

    content.push({
      text: enderecoCompleto || '',
      fontSize: 9,
      alignment: 'center' as const,
      margin: [0, 0, 0, 1] as Margins,
    });

    if (empresa?.telefone) {
      content.push({
        text: `FONE: ${empresa.telefone}`,
        fontSize: 9,
        alignment: 'center' as const,
        margin: [0, 0, 0, 2] as Margins,
      });
    }

    content.push({
      text: `CNPJ: ${empresa?.cnpj || '______________'}`,
      fontSize: 9,
      alignment: 'center' as const,
      margin: [0, 0, 0, 2] as Margins,
    });

    // SEPARADOR
    content.push({
      text: '-'.repeat(48),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 0, 0, 2] as Margins,
    });

    // DOCUMENTO SEM VALOR FISCAL
    content.push({
      text: 'DOCUMENTO SEM VALOR FISCAL',
      alignment: 'center' as const,
      bold: true,
      fontSize: 11,
      margin: [0, 0, 0, 2] as Margins,
    });

    content.push({
      text: '-'.repeat(48),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 0, 0, 2] as Margins,
    });

    // CABEÇALHO DO CUPOM
    content.push({
      columns: [
        {
          width: '*',
          text: `${isOrcamento ? 'ORÇAMENTO' : 'CUPOM'}: ${dados.numero}`,
          fontSize: 10,
        },
        {
          width: 'auto',
          text: moment(dados.dataoperacao).format('DD/MM/YYYY HH:mm'),
          fontSize: 10,
        },
      ],
      margin: [0, 0, 0, 2] as Margins,
    });

    // ===== TABELA DE ITENS =====
    // Cabeçalho da tabela (sem bordas)
    content.push({
      columns: [
        { width: 20, text: 'QTD', bold: true, fontSize: 9, alignment: 'left' as const },
        { width: 25, text: 'COD', bold: true, fontSize: 9, alignment: 'left' as const },
        { width: '*', text: 'DESCRIÇÃO', bold: true, fontSize: 9, alignment: 'left' as const },
        { width: 35, text: 'UNIT', bold: true, fontSize: 9, alignment: 'right' as const },
        { width: 35, text: 'TOTAL', bold: true, fontSize: 9, alignment: 'right' as const },
      ],
      margin: [0, 0, 0, 1] as Margins,
    });

    content.push({
      text: '-'.repeat(48),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 0, 0, 1] as Margins,
    });

    // Itens
    itensPagina.forEach((item) => {
      const codigo = item.referencia || '';
      const descricao = item.descricao || '';
      const descricaoTruncada = descricao.length > 30 ? descricao.substring(0, 30) + '...' : descricao;

      content.push({
        columns: [
          { 
            width: 20, 
            text: `${item.qtds.toLocaleString('pt-BR', { 
              minimumFractionDigits: 0, 
              maximumFractionDigits: 3 
            })} ${item.un || 'UN'}`,
            fontSize: 9,
            alignment: 'left' as const,
          },
          { 
            width: 25, 
            text: codigo.substring(0, 10),
            fontSize: 9,
            alignment: 'left' as const,
          },
          { 
            width: '*', 
            text: descricaoTruncada,
            fontSize: 9,
            alignment: 'left' as const,
          },
          { 
            width: 35, 
            text: item.preco.toFixed(2),
            fontSize: 9,
            alignment: 'right' as const,
          },
          { 
            width: 35, 
            text: item.subtotal.toFixed(2),
            fontSize: 9,
            alignment: 'right' as const,
            bold: true,
          },
        ],
        margin: [0, 1, 0, 1] as Margins,
      });
    });

    // SEPARADOR
    content.push({
      text: '-'.repeat(48),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 2, 0, 2] as Margins,
    });

    // ===== RESUMO =====
    content.push({
      columns: [
        { width: '*', text: 'SUBTOTAL:', fontSize: 10, alignment: 'left' as const },
        { width: '*', text: dados.vprod.toFixed(2), fontSize: 10, alignment: 'right' as const },
      ],
      margin: [0, 1, 0, 1] as Margins,
    });

    if (dados.desconto && dados.desconto > 0) {
      content.push({
        columns: [
          { width: '*', text: 'DESCONTO:', fontSize: 10, alignment: 'left' as const },
          { width: '*', text: `-${dados.desconto.toFixed(2)}`, fontSize: 10, alignment: 'right' as const },
        ],
        margin: [0, 1, 0, 1] as Margins,
      });
    }

    if (dados.acrescimo && dados.acrescimo > 0) {
      content.push({
        columns: [
          { width: '*', text: 'ACRÉSCIMO:', fontSize: 10, alignment: 'left' as const },
          { width: '*', text: dados.acrescimo.toFixed(2), fontSize: 10, alignment: 'right' as const },
        ],
        margin: [0, 1, 0, 1] as Margins,
      });
    }

    content.push({
      text: '='.repeat(48),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 2, 0, 2] as Margins,
    });

    content.push({
      columns: [
        { width: '*', text: 'TOTAL A PAGAR:', fontSize: 13, bold: true, alignment: 'left' as const },
        { width: '*', text: dados.total.toFixed(2), fontSize: 13, bold: true, alignment: 'right' as const },
      ],
      margin: [0, 1, 0, 2] as Margins,
    });

    content.push({
      text: '='.repeat(48),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 0, 0, 3] as Margins,
    });

    // ===== OBSERVAÇÕES =====
    if (dados.obs) {
      content.push({
        text: `OBS: ${dados.obs}`,
        fontSize: 9,
        margin: [0, 0, 0, 3] as Margins,
      });
    }

    // ===== CÓDIGO DE BARRAS =====
    content.push({
      image: codigoBarras,
      width: 180,
      alignment: 'center' as const,
      margin: [0, 0, 0, 3] as Margins,
    });

    // ===== RODAPÉ =====
    content.push({
      text: `${isOrcamento ? 'ORÇAMENTO' : 'CUPOM'}: ${dados.numero}`,
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 1, 0, 1] as Margins,
    });

    content.push({
      text: moment(dados.dataoperacao).format('DD/MM/YYYY HH:mm:ss'),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 1, 0, 1] as Margins,
    });

    if (paginas.length > 1) {
      content.push({
        text: `PÁGINA ${index + 1}/${paginas.length}`,
        alignment: 'center' as const,
        fontSize: 8,
        margin: [0, 1, 0, 1] as Margins,
      });
    }

    content.push({
      text: '*** DOCUMENTO SEM VALOR FISCAL ***',
      alignment: 'center' as const,
      bold: true,
      fontSize: 10,
      margin: [0, 2, 0, 2] as Margins,
    });

    content.push({
      text: '-'.repeat(48),
      alignment: 'center' as const,
      fontSize: 8,
      margin: [0, 0, 0, 1] as Margins,
    });

    // Quebra de página
    if (index < paginas.length - 1) {
      content.push({
        text: '',
        pageBreak: 'after' as const
      });
    }
  });

  // ===== CONFIGURAÇÃO =====
  const documentDefinition: TDocumentDefinitions = {
    pageSize: {
      width: 226.77, // 80mm
      height: 'auto' as const,
    },
    pageMargins: [10, 10, 10, 10] as Margins,
    content: content,
    defaultStyle: {
      font: 'Roboto',
      fontSize: 9,
    },
    compress: true,
  };

  return new Promise((resolve, reject) => {
    try {
      const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
      pdfDocGenerator.getBlob((blob) => {
        resolve(blob);
      });
    } catch (error) {
      reject(error);
    }
  });
}

export default PDFVendaTermica;